import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';

const ModalEditAnggota = ({ isOpen, onClose, onUpdate, anggotaData }) => {
  const [formData, setFormData] = useState(anggotaData);

  useEffect(() => {
    setFormData(anggotaData);
  }, [anggotaData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    // Auto-update tahun_lulus jika tahun_masuk diubah dan bukan guru
    if (name === 'tahun_masuk' && value && formData.kelas !== 'Guru') {
      setFormData({ 
        ...formData, 
        [name]: value,
        tahun_lulus: (parseInt(value) + 3).toString()
      });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await onUpdate(formData.id, formData);
      Swal.fire({
        icon: 'success',
        title: 'Berhasil',
        text: 'Data anggota berhasil diubah!'
      });
      onClose();
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Gagal',
        text: error.response?.data?.message || error.message || 'Terjadi kesalahan saat mengubah data anggota.'
      });
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal is-active">
      <div className="modal-background" onClick={onClose}></div>
      <div className="modal-card">
        <header className="modal-card-head">
          <p className="modal-card-title">Edit Anggota</p>
          <button className="delete" aria-label="close" onClick={onClose}></button>
        </header>
        <section className="modal-card-body">
          <form onSubmit={handleSubmit}>
            <div className="field">
              <label className="label">Kode Anggota</label>
              <div className="control">
                <input className="input is-static" type="text" value={formData.kode_anggota} readOnly />
              </div>
            </div>

            <div className="field">
              <label className="label">Nomor Induk Siswa</label>
              <div className="control">
                <input className="input" type="text" name="nis" value={formData.nis} onChange={handleChange} required />
              </div>
            </div>

            <div className="field">
              <label className="label">Nama Lengkap</label>
              <div className="control">
                <input className="input" type="text" name="nama_lengkap" value={formData.nama_lengkap} onChange={handleChange} required />
              </div>
            </div>

            <div className="field">
              <label className="label">Nama Pengguna</label>
              <div className="control">
                <input className="input" type="text" name="nama_pengguna" value={formData.nama_pengguna} onChange={handleChange} required />
              </div>
            </div>

            <div className="field">
              <label className="label">Kelas</label>
              <div className="control">
                <div className="select is-fullwidth">
                  <select name="kelas" value={formData.kelas} onChange={handleChange} required>
                    <option value="Guru">Guru</option>
                    <option value="Kelas 7A">Kelas 7A</option>
                    <option value="Kelas 7B">Kelas 7B</option>
                    <option value="Kelas 8A">Kelas 8A</option>
                    <option value="Kelas 8B">Kelas 8B</option>
                    <option value="Kelas 9A">Kelas 9A</option>
                    <option value="Kelas 9B">Kelas 9B</option>
                  </select>
                </div>
              </div>
            </div>

            {/* Field Status */}
            <div className="field">
              <label className="label">Status</label>
              <div className="control">
                <div className="select is-fullwidth">
                  <select name="status" value={formData.status || 'aktif'} onChange={handleChange} required>
                    <option value="aktif">Aktif</option>
                    <option value="nonaktif">Nonaktif</option>
                  </select>
                </div>
              </div>
            </div>

            {/* Field Tahun Masuk - hanya untuk siswa */}
            {formData.kelas !== 'Guru' && (
              <div className="field">
                <label className="label">Tahun Masuk</label>
                <div className="control">
                  <input 
                    className="input" 
                    type="text" 
                    name="tahun_masuk" 
                    value={formData.tahun_masuk || ''} 
                    onChange={handleChange}
                    placeholder="Tahun masuk (misal: 2025)"
                  />
                </div>
                {formData.tahun_masuk && (
                  <p className="help">Tahun lulus: {parseInt(formData.tahun_masuk) + 3}</p>
                )}
              </div>
            )}

            {/* Field Keterangan Status - hanya muncul jika nonaktif */}
            {formData.status === 'nonaktif' && (
              <div className="field">
                <label className="label">Keterangan Status</label>
                <div className="control">
                  <textarea 
                    className="textarea" 
                    name="keterangan_status" 
                    value={formData.keterangan_status || ''} 
                    onChange={handleChange}
                    placeholder="Alasan nonaktif: Lulus, Pindah, DO, dll"
                  />
                </div>
              </div>
            )}

            <div className="field">
              <label className="label">
                Kata Sandi <span className="has-text-danger">*tidak wajib diisi</span>
              </label>
              <div className="control">
                <input
                  className="input"
                  type="password"
                  name="kata_sandi"
                  value={formData.kata_sandi || ''}
                  onChange={handleChange}
                  placeholder="Kosongkan jika tidak ingin mengubah"
                />
              </div>
            </div>

            <div className="field">
              <label className="label">Alamat</label>
              <div className="control">
                <textarea className="textarea" name="alamat" value={formData.alamat} onChange={handleChange} placeholder="Masukan Alamat" required></textarea>
              </div>
            </div>

            <div className="field">
              <div className="control">
                <button type="submit" className="button is-info is-fullwidth">Update</button>
              </div>
            </div>
          </form>
        </section>
      </div>
    </div>
  );
};

export default ModalEditAnggota;